import type { ReactNode } from 'react';

export function DataTable({
  headers,
  children,
  empty,
}: {
  headers: string[];
  children: ReactNode;
  empty?: boolean;
}) {
  if (empty) return null;
  return (
    <div className="overflow-x-auto rounded-xl border border-[var(--border)] bg-white/80">
      <table className="min-w-full text-left text-sm">
        <thead className="border-b border-[var(--border)] bg-dome-forest/5 text-xs uppercase tracking-wide text-[var(--muted)]">
          <tr>
            {headers.map((h) => (
              <th key={h} className="px-3 py-2 font-medium">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-[var(--border)]">{children}</tbody>
      </table>
    </div>
  );
}
